import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})
export class MailingService {
  // get enquiriesEmail() {
  //   return this.dataService.organizationData.enquiries_email;
  // }

  private mailingServiceUrl = environment.apiUrl;

  // The organization logo fields are already absolute asset URLs, so they are
  // used as-is. The email template renders the logo on a white background, so it
  // needs the dark version - light_logo_img is fill:#fff and would be invisible.
  // A getter, not a field, so it reads the organization data at send time rather
  // than at construction time (when it may not have loaded yet).
  get logo() {
    const organizationData = this.dataService.organizationData;
    return organizationData?.dark_logo_img ?? organizationData?.logo_img ?? '';
  }

  constructor(private http: HttpClient, private dataService: DataService) {}

  sendMessage(message) {
    const body = {
      client: environment.client_email,
      message: message,
    };

    body.message.logo = this.logo;

    console.log('BODY', body);

    return this.http.post(`${this.mailingServiceUrl}/mailing/mail`, body, {
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
    });
  }
}
